import { render, staticRenderFns } from "./YoutubeElement.vue?vue&type=template&id=d85f1b72&"
import script from "./YoutubeElement.vue?vue&type=script&lang=js&"
export * from "./YoutubeElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports